<template>
  <div class="header">
    <div class="row flex">
      <div class="col1 flex">
        <figure class="logo"><img src="@/assets/images/Simpas_Applied_Solutions.svg" alt="Simpas Applied Solutions"></figure>
        <div class="flex flex-col flex-full">
          <h1>SIMPAS-applied Solutions&trade;</h1>
          <h2>Farm Benefit Tool</h2>
        </div>
      </div>

      <div class="col2">
        <div class="instructions">
            <div class="calculator-guide">
                <h3 class="accordion">Calculator Guide 
                    <div class="accordion accordion__arrow" aria-expanded="false" role="button" tabindex="0">
                        <div class="icon">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </h3>
                <div class="panel">
                    <ol>
                        <li><strong>Select a Crop</strong> in the Input&nbsp;section.</li>
                        <li>Enter the <strong>Commodity&nbsp;Price</strong>.</li>
                        <li>Enter the <strong>Number of Acres&nbsp;Grown</strong>.</li>
                        <li>Choose up to 3 <strong>Treatment Needs</strong>, select the desired <strong>Product</strong>, then fill in the <strong>Percentage</strong> of the field requiring&nbsp;treatment.</li>
                        <li><strong>Prescriptive Application</strong> and <strong>Whole Field Application</strong> values are calculated&nbsp;automatically.</li>
                        <li>Adjust the <strong>Average Yield Increase Per Acre</strong> number to see the effect&nbsp;on&nbsp;value.</li>
                        <li>Finish by printing your results to review with your crop inputs&nbsp;retailer.</li>
                    </ol>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  methods: {
      toggleAccordion(evt) {
          var acc = document.querySelector(".accordion");
          var panel = acc.nextElementSibling;
          if(evt.type == 'click') {
              acc.classList.toggle("active");
              if (panel.style.maxHeight) {
                  panel.style.maxHeight = null;
              } else {
                  panel.style.maxHeight = panel.scrollHeight + "px";
              }
          }
          if(evt.type == 'resize' && acc.classList.contains('active')) {
              panel.style.maxHeight = panel.scrollHeight + "px";
          }
      }
    },
    mounted: function() {
        document.querySelector(".accordion").addEventListener('click', this.toggleAccordion, false);
        window.addEventListener('resize', this.toggleAccordion, false);

        document.querySelector('nav a').addEventListener('click', function () {
            event.preventDefault();
            history.back();
        });
    }
}
</script>